import React from 'react';
import { Input } from 'antd';

const { TextArea } = Input;

const EPTextArea = props => {
  return <TextArea size="large" {...props} />;
};

export default EPTextArea;
